import React from "react";
import { Grid } from "@mui/material";
import "../../styles/new_design.scss";
import HeaderUtah from "../../components/ui/header/HeaderUtah";
// import InsideDesign from "../../components/newDesign";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import CustomAnimationDesign from "./customAnimationContent";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel({ children, value, index }: TabPanelProps) {
  return (
    <div hidden={value !== index} role="tabpanel" id={`tabpanel-${index}`}>
      {value === index && (
        <Box sx={{ p: 2 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `tab-${index}`,
    "aria-controls": `tabpanel-${index}`,
  };
}

const tabLabels = ["Crani", "Sealonix", "Gutlab", "Liger"];


const CustomAnimations: React.FC = () => {

      const [value, setValue] = React.useState(0);
    
      const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue);
      };
  return (
    <Grid className="approot new_design">
      <HeaderUtah />
      <Box sx={{ padding: "0px !important" }}>
        <Grid container>
          <Grid item className="tabdesc" xs={12} md={8.5} sm={12}>
            <Box sx={{ width: "100%", marginTop: "20px" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="tabs example"
              >
                {tabLabels.map((label, index) => (
                  <Tab
                    key={label}
                    label={label}
                    {...a11yProps(index)}
                    sx={{
                      backgroundColor:
                        value === index ? "#004684" : "transparent",
                      color: value === index ? "#fff !important" : "inherit",
                      borderRadius: 1,
                      minWidth: 50,
                      minHeight: 30,
                      textTransform: "none",
                      fontWeight: 600,
                      mx: 0.5,
                      border: "none !important",
                    }}
                  />
                ))}
              </Tabs>
            </Box>
          </Grid>
        </Grid>
        {tabLabels.map((label, index) => (
          <Box className="customTabcontent" sx={{ padding: "0px !important" }}>
            <TabPanel key={index} value={value} index={index}>
              {/* <CustomAnimationDesign category={label} /> */}
              <CustomAnimationDesign category={label} />
            </TabPanel>
          </Box>
        ))}
      </Box>
    </Grid>
  );
};
export default CustomAnimations;